/*
 * @Author: Chao Yang
 * @Date: 2020-08-05 02:00:49
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-09-07 13:55:36
 */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { getYear, lastDayOfMonth } from 'date-fns';

@Component({
  selector: 'year-picker',
  templateUrl: './year-picker.component.html',
})
export class YearPickerComponent implements OnInit {
  yearList: number[];
  firstYear: number;
  lastYear: number;
  currentPage: number;
  currentYear: number;
  pageSize = 10;
  @Input() currentDate: Date = new Date();

  @Input() minDate: Date;
  @Input() maxDate: Date;

  @Output() onSelect: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
    const year = getYear(this.currentDate);
    this.currentYear = year;
    this.currentPage = Math.floor((year - 1900) / this.pageSize);
    this.generateYearList();
  }

  yearClick(year: number) {
    this.onSelect.emit(year);
  }

  previousPage() {
    this.currentPage -= 1;
    if (this.currentPage < 0) {
      this.currentPage = 0;
    }
    this.generateYearList();
  }

  nextPage() {
    this.currentPage += 1;
    this.generateYearList();
  }

  generateYearList() {
    const list = [];
    const startYear = this.currentPage * this.pageSize + 1900;
    this.firstYear = startYear;
    list.push(startYear - 1);
    for (let i = 0; i < this.pageSize; i++) {
      list.push(startYear + i);
    }
    this.lastYear = list[list.length - 1];
    list.push(this.lastYear + 1);
    this.yearList = list;
  }

  isValidYear(year: number) {
    if (this.maxDate && new Date(year, 0, 1) > this.maxDate) {
      return false;
    }
    if (this.minDate && lastDayOfMonth(new Date(year, 11, 1)) < this.minDate) {
      return false;
    }
    return true;
  }
}
